import { useRef, useState } from 'react';
import FormQrCustom from '../components/FormQrCustom';
import QrCard from '../components/QrCard';

const Generador = () => {

	const qrRef = useRef();

	const [url, setUrl] = useState(''),
			[qrColor, setQrColor] = useState('#000000'),
			[qrBgColor, setQrBgColor] = useState('#ffffff'),
			[customImg, setCustomImg] = useState(''),
			[noImg, setNoImg] = useState(false);
			
	const handleQrReset = () => {
		setUrl(''); 
		setQrColor('#000000');
		setQrBgColor('#ffffff');
		setCustomImg('');
		setNoImg(false);
	}

    return (
		<>

			<main>
				<FormQrCustom
					qrRef={qrRef}
					url={url}
					qrColor={qrColor}
					qrBgColor={qrBgColor}
					noImg={noImg}
					setUrl={setUrl}
					setQrColor={setQrColor}
					setQrBgColor={setQrBgColor}
					setCustomImg={setCustomImg}
					setNoImg={setNoImg}
					handleQrReset={handleQrReset}
				/> 

				<QrCard
					qrRef={qrRef}
					url={url}
					qrColor={qrColor}
					bgColor={qrBgColor}
					customImg={customImg}
					noImg={noImg}
				/>
			</main>
		</>
	);

}
export default Generador